export const BrandIdentityTabs = {
  OVERVIEW: 'overview',
  CHANNELS: 'channels',
  DATA: 'data'
};